/** Formatting of file names, sizes and dates for the file lists. */

const KIB = 1024;
const MIB = KIB * KIB;

/** Lower-case extension of a file name without the dot ("" when it has none). */
export function extensionOf(name: string): string {
  const base = name.slice(
    Math.max(name.lastIndexOf("/"), name.lastIndexOf("\\")) + 1,
  );
  const dot = base.lastIndexOf(".");
  return dot <= 0 ? "" : base.slice(dot + 1).toLowerCase();
}

/** "1.5 MB" above a megabyte, "12 KB" below (as the old site showed sizes). */
export function formatSize(bytes: number, locale?: string): string {
  if (bytes > MIB) {
    const value = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(bytes / MIB);
    return `${value} MB`;
  }
  const value = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
  }).format(Math.round(bytes / KIB));
  return `${value} KB`;
}

/**
 * Date and time in the visitor's locale and time zone, numeric (no month
 * names from another language on the English pages).
 */
export function formatDateTime(
  date: Date,
  locale?: string,
  timeZone?: string,
): string {
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...(timeZone === undefined ? {} : { timeZone }),
  }).format(date);
}
